import React from 'react'

import { theme } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'

import {
  TABLE_OF_CONTENT_GROW_LEAF_CAROUSEL,
  TABLE_OF_CONTENT_SECTION,
} from 'utils/testing/testIDs'

import { ScrollBarWrapper } from '../../shared/ScrollBarWrapper/ScrollBarWrapper'
import { publishingColors } from '../../styles'
import { Card } from './Card'
import { CarouselContainer } from './styled-components'

const getCarouselContent = (custodianNickname: string) => [
  {
    backgroundColor: theme.colors.lightOak,
    content: `early.recap.table_of_contents.carousel.contributions.description.variable`,
    contentVariable: [custodianNickname],
    title: 'early.recap.table_of_contents.carousel.contributions.title',
  },
  {
    backgroundColor: theme.colors.mushroom,
    content: 'early.recap.table_of_contents.carousel.gifts.description',
    title: 'early.recap.table_of_contents.carousel.gifts.title',
  },
  {
    backgroundColor: publishingColors.backgroundBlack,
    content: 'early.recap.table_of_contents.carousel.performance.description',
    title: 'early.recap.table_of_contents.carousel.performance.title',
  },
  {
    backgroundColor: theme.colors.mushroom,
    content: 'early.recap.table_of_contents.carousel.potential.description',
    title: 'early.recap.table_of_contents.carousel.potential.title',
  },
]

const CARD_WIDTH = 180
const CARD_GAP = 20

const Carousel = ({
  custodianNickname,
}: {
  custodianNickname: string
}): React.ReactElement => {
  const { getRemoteString } = useRemoteStrings()

  const carouselContent = getCarouselContent(custodianNickname)
  const cardCount = carouselContent.length

  return (
    <ScrollBarWrapper
      contentWidth={CARD_WIDTH * cardCount + CARD_GAP * (cardCount - 1)}
      sectionId={TABLE_OF_CONTENT_SECTION}
    >
      <CarouselContainer data-testid={TABLE_OF_CONTENT_GROW_LEAF_CAROUSEL}>
        {carouselContent.map((card, index) => {
          const content = getRemoteString({
            key: card.content,
            variables: card.contentVariable,
          })
          const title = getRemoteString({
            key: card.title,
          })

          return (
            <Card
              backgroundColor={card.backgroundColor}
              content={content}
              index={index}
              key={card.title}
              title={title}
            />
          )
        })}
      </CarouselContainer>
    </ScrollBarWrapper>
  )
}

export { Carousel }
